import React, { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { useTheme } from '@material-ui/core/styles'

import * as userRoutes from './views/routes'
import { useUserType } from './ducks/auth/hooks'
import { isAuthenticated } from './auth/utils'
import { consumePostLoginRedirect } from './reusable/postLoginRedirect'

const RootRoute = () => {
  const theme = useTheme()
  const userType = useUserType()
  // After logging in the backend always sends the browser to `/`; resume the
  // page that sent the user to log in, if any (e.g. the MCP consent page).
  const [resumePath] = useState(() =>
    isAuthenticated() ? consumePostLoginRedirect() : null
  )
  return (
    <Redirect
      to={resumePath || theme.rootRoutes?.[userType] || '/dashboard/default'}
    />
  )
}

const redirectRoute = [
  {
    path: '/',
    exact: true,
    component: RootRoute,
  },
]

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />,
  },
]

const routes = [...redirectRoute, ...Object.values(userRoutes), ...errorRoute]

export default routes
